import { useContext, useState } from 'react';
import { AuditionTitle } from 'organisms/AuditionTitle';
import { MessageSection } from 'organisms/u011/MessageSection';
import { AppContext } from 'templates/AppContextProvider';
import { AppFooter } from 'templates/AppFooter';
import { AppHeader } from 'templates/AppHeader';
import { BackButton } from 'atoms/BackButton';
import { MediaQueryEnum, useMediaQuery } from 'commons/utils';
import { useParams } from 'react-router-dom';
import { NotFound } from './404';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import MessageModal from 'organisms/MessageModal';

export const Message = () => {
  const ctx = useContext(AppContext);
  const [error, setError] = useState<string | null>(null);
  const userId = ctx.userId;
  const routeParams = useParams();
  const { audition_id } = routeParams;
  const [auditionTitle, setAuditionTitle] = useState<string>(ctx.selectedAuditionTitle);
  const isSp = useMediaQuery(MediaQueryEnum.sp);
  const { t: tCommon } = useTranslationWithLang('commons');
  if (!audition_id) {
    return <NotFound />;
  }
  if (isSp) {
    return (
      <>
        {error && (
          <MessageModal
            message={error}
            closeLabel={tCommon('TU000_028')}
            onClose={() => {
              setError('');
            }}
          />
        )}
        <div
          className="h-full flex overflow-auto justify-center"
          style={{ background: 'var(--c-background)' }}
        >
          <AppHeader />
          <div className="flex flex-col items-center w-full h-full text-[--c-text] bg-[--c-bg] pt-20 pb-24">
            <div className="flex flex-col w-full justify-center bg-[--c-background2]">
              <AuditionTitle title={auditionTitle} withTopLink={false}></AuditionTitle>
            </div>
            <div className="flex h-[40rem] w-full flex-col pt-10">
              <div className="flex flex-col h-full w-full grow items-center px-2 pb-20">
                <MessageSection
                  userId={userId}
                  auditionId={audition_id}
                  setAuditionTitle={setAuditionTitle}
                  catchError={(err: string) => setError(err)}
                ></MessageSection>
                <div className="flex justify-center">
                  <BackButton className="w-[9rem]" />
                </div>
              </div>
            </div>
          </div>
          <AppFooter />
        </div>
      </>
    );
  }

  return (
    <>
      {error && (
        <MessageModal
          message={error}
          closeLabel={tCommon('TU000_028')}
          onClose={() => {
            setError('');
          }}
        />
      )}
      <div
        className="h-screen h-full flex overflow-auto justify-center"
        style={{ background: 'var(--c-background)' }}
      >
        <AppHeader />
        <main className="flex flex-col items-center w-full h-full text-[--c-text] bg-[--c-bg] pt-20 pb-32">
          <div className="flex flex-col w-full justify-center items-center bg-[--c-background2]">
            <AuditionTitle title={auditionTitle} withTopLink={false}></AuditionTitle>
          </div>
          <div className="flex h-[80%] flex-col pt-10 w-[70%]">
            <div className="flex flex-col h-full w-full grow justify-center items-center">
              <MessageSection
                userId={userId}
                auditionId={audition_id}
                setAuditionTitle={setAuditionTitle}
                catchError={(err: string) => setError(err)}
              ></MessageSection>
              <div className="pt-4 pb-6 h-8">
                <BackButton style={{ margin: '0' }} />
              </div>
            </div>
          </div>
        </main>
        <AppFooter />
      </div>
    </>
  );
};
